module.exports = __webpack_public_path__ + "7d3234f143e799d74d89e5b61f25c4d2.svg";